import i18n from 'l10n';
import BaseView from 'js/views/subscribers.base.view';
import SubscriberModel from 'js/models/subscriber.model';
import SubscribersCollection from 'js/models/subscribers.collection';
import RowView from 'js/views/subscriber.listgroup.row.view';
import Template from 'js/templates/subscribers.listgroup.hbs';
import callingcode from 'callingcodewithdefaultcountry';
import Queryable from 'js/traits/queryable.trait';
import {_} from "backboneAdapter";
import {domain, el, on, tagName, template} from "../adapters/backbone-decorators";

@el("#contacts-container")
@tagName('span')
@domain('.page')
@template(Template)
class SubscribersListgroupView extends BaseView {

    @on('keyup .searchbox')
    dosearch(fromQb) {
        super.dosearch(fromQb);
    }

    constructor(options) {
        super(options);
        this.inContactsSearch = false;
        // this.totalContactsLength = 0;
        _.extend(this, Queryable);
        this.SubscriberView = RowView;
        this.subscribersCollection = new SubscribersCollection();
        google.charts.load('current', {
            packages: ['geochart'],
            language: i18n.language
        });
    }

    async renderView() {
        super.renderView();
        const regionWrap = document.getElementById('regions_wrapper');
        const chartRegion = document.getElementById('regions_div');

        await this.initFilters();
        this.$('#builder-plugins').on('afterUpdateRuleValue.queryBuilder', function (e, rule) {
            if (rule.filter.plugin === 'datetimepicker') {
                var $input = rule.$el.find('.rule-value-container [name*=_value_]');
                $input.on('dp.change', function () {
                    $input.trigger('change');
                });
            }
        });

        this.$('#builder-plugins').queryBuilder(this.queryBuilderOptions);

        this.$('#btn-get').on('click', () => {
            var result = $('#builder-plugins').queryBuilder('getRules');

            if (!$.isEmptyObject(result)) {
                console.log(JSON.stringify(result, null, 2));
                let parsedQuery = this.rulesToParsedQuery(result);
                console.log(JSON.stringify(parsedQuery, null, 2));
                let query = this.parsedQueryToQuery(parsedQuery, false);
                let querySearch = `q:${query}`;
                console.log(query);
                this.$el.find('.searchbox').val(querySearch);
                this.dosearch(false);
            }
        });
        this.$('#btn-create').on('click', () => {
            var result = $('#builder-plugins').queryBuilder('getRules');

            if (!$.isEmptyObject(result)) {
                console.log(JSON.stringify(result, null, 2));
                let parsedQuery = this.rulesToParsedQuery(result);
                console.log(JSON.stringify(parsedQuery, null, 2));
                let query = this.parsedQueryToQuery(parsedQuery, false);
                this.trigger("createQueryGroup", 'calc', query);
            }
        });

        this.$('#btn-close').on('click', () => {
            this.$('.querybuilder').hide();
        });

        try {
            const response = await $.ajaxDefaultQ({
                url: '/CampaignCloud/Subscription/countSubscriptionsByCountryCode' //does not count subscriptions with `countryCode = null`
            });

            if (chartRegion) {
                const drawRegionsMap = function () {
                    const headerAndNumbers = [["Region", "#"]].concat(response);
                    const data = google.visualization.arrayToDataTable(headerAndNumbers);

                    const button = $('#mobiles-per-country');
                    if (response.length > 0) {
                        const drawToggle = function () {
                            if ($(regionWrap).is(':visible')) {
                                $(regionWrap).hide();
                                button.addClass('bg-zanteBlue');
                                button.removeClass('bg-funkyOrange');
                            } else {
                                $(regionWrap).show();
                                button.removeClass('bg-zanteBlue');
                                button.addClass('bg-funkyOrange');

                                const options = {
                                    width: $(chartRegion).css("width"),
                                    height: $(chartRegion).css("height")
                                };
                                const chart = new google.visualization.GeoChart(chartRegion);
                                chart.draw(data, options);
                            }
                        };
                        const redraw = function () {
                            if (!$(regionWrap).is(':visible')) {
                            } else {
                                const options = {
                                    width: $(chartRegion).css("width"),
                                    height: $(chartRegion).css("height")
                                };
                                const chart = new google.visualization.GeoChart(chartRegion);
                                chart.draw(data, options);
                            }
                        };
                        button.click(drawToggle);
                        $(window).on('resize', _.debounce(function (evt) {
                            redraw();
                        }, 10));
                    } else {
                        button.hide();
                    }
                };

                google.charts.setOnLoadCallback(drawRegionsMap);
            }
        } catch (e) {
            console.error(e);
        }
    }

    hide() {
        this.$el.parent().parent().hide();
    }

    show() {
        this.$el.parent().parent().show();
    }

    modelRendering(model, el) {
        model.set("postpaid", this.model.get("postpaid"));
        const view = new this.SubscriberView({model});
        view.render();
        const elInner = view.el;
        $(el).html('');
        $(el).append(elInner);
    }

    @on('click #new-contact')
    newSubscriber(e) {
        const model = new SubscriberModel();
        model.set("subscriber", {});
        const $email = $("#email-msisdn");
        const value = $email.val();

        if ($email.data("contacttype") === 1) {
            model.set("subscriber", {email: value});
        } else {
            model.set("msisdn", value);
        }

        model.save(model.attributes, {
            success() {
                if (typeof model.get(model.idAttribute) === 'undefined') {
                    $.Notify.error(i18n.t("contacts.contactslimitexceedederror"));
                } else {
                    location.href = `Contacts.htm#${model.get(model.idAttribute)}`;
                }
            },
            error(model, xhr) {
                let message = null;
                console.info(value);
                switch (xhr.status) {
                    case 590:
                        message = i18n.t("contacts.existingmsisdn", {msisdn: value});
                        break;
                    case 591:
                        message = i18n.t("contacts.existingemail", {email: value});
                        break;
                    case 592:
                        message = i18n.t("contacts.contactlimit");
                        break;
                    case 593:
                        message = i18n.t("contacts.invaliddomain");
                        break;
                    default:
                        message = i18n.t("contacts.generalexception");
                        break;
                }

                $.Notify.error(message);
            }
        });
    }

    @on('keyup #email-msisdn')
    checkMailOrMsisdn() {
        const $email = $("#email-msisdn");
        let value = $email.val();

        const $msisdn = $("#msisdn-flag");
        if (value.length) {
            const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,63}$/i;
            if (value.indexOf("00") === 0) {
                value = "+" + value.substring(2);
            }

            let c;
            let parsedPhoneNum;
            let numberType;
            try {
                parsedPhoneNum = callingcode.parseAndKeepRawInput(value, callingcode.defaultCountryCode);
                c = callingcode.getRegionCodeForNumber(parsedPhoneNum);
                numberType = callingcode.getNumberType(parsedPhoneNum);
            } catch (e) {
                console.info(`Unable to get region code for number: ${value} ${e}`);
            }
            if (emailRegex.test(value)) {
                $email.removeClass('required-input');
                $email.removeClass('invalid-input');
                $email.removeClass('confirm-failure-input-borders');
                $email.addClass('valid-input');
                $email.data("contacttype", 1);
                $('#email-msisdn-error-message').empty();
                $msisdn.hide();
                $('#new-contact').removeAttr('disabled');
            } else if (numberType === 1 || numberType === 2) {
                $msisdn.removeClass();
                $msisdn.addClass("flag-icon");
                $email.removeClass('required-input');
                $email.removeClass('invalid-input');
                $email.removeClass('confirm-failure-input-borders');
                $email.addClass('valid-input');
                $email.data("contacttype", 2);
                $('#email-msisdn-error-message').empty();
                if (c) {
                    $msisdn.addClass(`flag-icon-${c.toLowerCase()}`);
                    value = callingcode.format(parsedPhoneNum, callingcode.FORMAT.E164);
                    $email.val(value);
                    $msisdn.show();
                } else {
                    $msisdn.addClass(`flag-icon-${callingcode.defaultCountryCode.toLowerCase()}`);
                    value = callingcode.format(parsedPhoneNum, callingcode.FORMAT.E164);
                    $email.val(value);
                    $msisdn.show();
                }
                $('#new-contact').removeAttr('disabled');
            } else {
                $email.removeClass('required-input');
                $email.removeClass('valid-input');
                $email.addClass('invalid-input');
                $email.addClass('confirm-failure-input-borders');
                const exampleNumber = callingcode.getExampleNumberForType(callingcode.defaultCountryCode, 1);
                const errorMessage = i18n.t("contacts.msisdnemailerror", {
                    examplenumber: `+${exampleNumber.getCountryCode()}${exampleNumber.getNationalNumber()}`
                });
                $('#email-msisdn-error-message').text(errorMessage);
                $msisdn.hide();
                $('#new-contact').attr('disabled', true);
            }
        } else {
            $email.removeClass('required-input');
            $email.removeClass('invalid-input');
            $email.removeClass('confirm-failure-input-borders');
            $email.removeClass('valid-input');
            $('#new-contact').attr('disabled', true);
            $msisdn.hide();
            $('#email-msisdn-error-message').empty();
        }
    }

    @on('change #filterBounce input[type="radio"]')
    onRadioSelectionChange(event) {
        const selectedValue = event.target.value;

        super.doFilterBounce(selectedValue);
    }
}

export default SubscribersListgroupView;
